/**
 * /automation-accounts/new — thin route shim for the Create
 * automation account page. Owns the literal navigate target so the
 * feature page stays route-agnostic.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CreateAutomationAccountPage } from "@/features/automation-accounts/pages/create-automation-account-page";

function PlatformCreateAutomationAccountPage() {
  const navigate = useNavigate();
  return (
    <CreateAutomationAccountPage
      tenantID={null}
      scope="platform"
      basePath="/automation-accounts"
      onBackToList={() => void navigate({ to: "/automation-accounts" })}
    />
  );
}

export const Route = createFileRoute("/_authed/automation-accounts/new")({
  component: PlatformCreateAutomationAccountPage,
});
